"use strict";(()=>{var w;(function(i){i.FIRST_PARTY="firstParty",i.THIRD_PARTY="thirdParty"})(w||(w={}));var g=Object.freeze({markWidgetLoaded:i=>{typeof window!="undefined"&&window.performance&&window.performance.mark&&window.performance.mark(`yotpo:${i}:loaded`)},markWidgetStart:(i,e)=>{typeof window!="undefined"&&window.performance&&window.performance.mark&&window.performance.mark(`yotpo:${i}:start`,{detail:e})},markWidgetEnd:(i,e)=>{typeof window!="undefined"&&window.performance&&window.performance.mark&&window.performance.mark(`yotpo:${i}:end`,{detail:e})}});var P=()=>{var i,e;return!(typeof window.Yotpo=="undefined"||!(!((i=window==null?void 0:window.yotpoWidgetsContainer)===null||i===void 0)&&i.Analytics)||!(!((e=window==null?void 0:window.yotpoWidgetsContainer)===null||e===void 0)&&e.AnalyticsTools))},f={},z=i=>{let{guid:e,category:r}=i;return`${e}_${r}`},_=i=>{let e=z(i);return f[e]||(f[e]=new y(i)),f[e]},y=class{constructor(e){this.getYotpoAnalytics(e)}async trackCustomWidgetAction(e,r,o,a){return this.trackWidgetEvent(e,r,o,a)}async trackClickedOn(e,r,o){return this.trackWidgetEvent("clicked_on",e,r,o)}async trackError(e,r,o){return this.trackWidgetEvent("error",e,r,o)}async trackFilterResults(e,r,o){return this.trackWidgetEvent("filter_results",e,r,o)}async trackHidden(e,r,o){return this.trackWidgetEvent("hidden",e,r,o)}async trackHook(e,r,o){return this.trackWidgetEvent("hook",e,r,o)}async trackHovered(e,r,o){return this.trackWidgetEvent("hovered",e,r,o)}async trackLoaded(e,r,o){return this.trackWidgetEvent("loaded",e,r,o)}async trackShown(e,r,o){return this.trackWidgetEvent("shown",e,r,o)}async trackWidgetLoaded(e,r,o){let a=await this.analyticsLoadingPromise;return a?a.trackWidgetLoaded(e,r,o):Promise.resolve(!1)}async getDomainUserId(){return this.analyticsLoadingPromise.then(e=>e?e==null?void 0:e.getDomainUserId():null)}async getHashFunction(){return this.analyticsLoadingPromise.then(e=>e?e==null?void 0:e.getHashFunction():()=>"")}createYotpoAnalyticsWithRetries(e,r,o){if(e<=0){r(!1);return}if(!P()){setTimeout(()=>{e-=1,this.createYotpoAnalyticsWithRetries(e,r,o)},50);return}r(!0)}getYotpoAnalytics(e){return this.analyticsLoadingPromise||(this.analyticsLoadingPromise=new Promise((r,o)=>{this.createYotpoAnalyticsWithRetries(10,r,o)}).then(r=>r?window.yotpoWidgetsContainer.AnalyticsTools.WidgetsAnalyticsFactory(e):null)),this.analyticsLoadingPromise}async trackWidgetEvent(e,r,o,a){let n=await this.analyticsLoadingPromise;return n?n==null?void 0:n.trackWidgetEvent(e,r,o,a):Promise.resolve(!1)}};var m=null;function v(i){return m=_(i),m}function b(){if(!m)throw new Error("Analytics not initialized. Call initAnalytics() first.");return m}var t="cliganic-rewards-dialog",l="cliganic-rewards-dialog-scrim";function F(){let i=null;try{i=b()}catch(r){}let e=(r,o)=>{try{i&&typeof i[r]=="function"&&i[r](...o)}catch(a){console.warn(`[claim-rewards-dialog] analytics.${r} failed`,a)}};return{trackShown:(r,o,a)=>e("trackShown",[r,o,a]),trackHidden:(r,o)=>e("trackHidden",[r,o]),trackClickedOn:(r,o)=>e("trackClickedOn",[r,o])}}function H(i){let{theme:e,fonts:r}=i;return`
    @import url('${r.googleFontsUrl}');

    .${l} {
      position: fixed;
      inset: 0;
      z-index: 2147483000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: clamp(12px, 3vw, 32px);
      background: rgba(26, 43, 42, 0.45);
      backdrop-filter: blur(6px);
      -webkit-backdrop-filter: blur(6px);
      opacity: 0;
      transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      will-change: opacity;
    }

    .${l}--visible {
      opacity: 1;
    }

    .${t} *,
    .${t} *::before,
    .${t} *::after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }

    .${t} {
      --color-primary: ${e.colorPrimary};
      --color-secondary: ${e.colorSecondary};
      --color-accent: ${e.colorAccent};
      --color-background: ${e.colorBackground};
      --color-surface: ${e.colorSurface};
      --color-text-primary: ${e.colorTextPrimary};
      --color-text-muted: ${e.colorTextMuted};
      --color-cta-bg: ${e.colorCtaBg};
      --color-cta-text: ${e.colorCtaText};
      --color-cta-hover: ${e.colorCtaHover};
      --color-badge-bg: ${e.colorBadgeBg};
      --color-badge-text: ${e.colorBadgeText};
      --color-panel-bg: ${e.colorPanelBg};
      --color-overlay-bg: ${e.colorOverlayBg};
      --color-overlay-text: ${e.colorOverlayText};
      --color-highlight-bg: ${e.colorHighlightBg};
      --color-link: ${e.colorLink};
      --radius-card: ${e.cardBorderRadius};
      --radius-button: ${e.buttonBorderRadius};
      --radius-badge: ${e.badgeBorderRadius};
      --font-display: ${r.display};
      --font-body: ${r.body};

      position: relative;
      display: grid;
      grid-template-columns: 1fr 1fr;
      width: 100%;
      max-width: 960px;
      max-height: 92vh;
      background: var(--color-surface);
      border-radius: var(--radius-card);
      overflow: hidden;
      box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.14),
        0 24px 64px rgba(0, 0, 0, 0.12);
      opacity: 0;
      transform: translateY(16px) scale(0.98);
      transition: opacity 0.45s cubic-bezier(0.4, 0, 0.2, 1),
                  transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);
      will-change: opacity, transform;
    }

    .${t}--visible {
      opacity: 1;
      transform: translateY(0) scale(1);
    }

    /* Close button */
    .${t}__close {
      position: absolute;
      top: 16px;
      right: 16px;
      z-index: 5;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(253, 251, 247, 0.9);
      border: 1px solid rgba(26, 43, 42, 0.12);
      border-radius: 50%;
      cursor: pointer;
      color: var(--color-text-muted);
      transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
                  background-color 0.2s, color 0.2s;
    }

    .${t}__close:hover {
      background: #fff;
      color: var(--color-text-primary);
      transform: scale(1.08) rotate(90deg);
    }

    .${t}__close svg {
      width: 18px;
      height: 18px;
    }

    /* Left column \u2014 product panel */
    .${t}__panel {
      position: relative;
      background: var(--color-panel-bg);
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      min-height: 0;
    }

    .${t}__product-img {
      width: auto;
      max-width: 100%;
      height: 72%;
      object-fit: contain;
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .${t}__panel:hover .${t}__product-img {
      transform: scale(1.04);
    }

    /* Floating retailer badges */
    .${t}__retailer-badge {
      position: absolute;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 14px;
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      border-radius: 28px;
      box-shadow:
        0 2px 8px rgba(0, 0, 0, 0.08),
        0 4px 16px rgba(0, 0, 0, 0.05);
      animation: ${t}-floatIn 0.6s cubic-bezier(0.4, 0, 0.2, 1) backwards;
    }

    .${t}__retailer-badge:nth-child(1) {
      top: 14%;
      left: 7%;
      animation-delay: 0.35s;
    }

    .${t}__retailer-badge:nth-child(2) {
      top: 34%;
      right: 5%;
      left: auto;
      animation-delay: 0.5s;
    }

    .${t}__retailer-badge:nth-child(3) {
      bottom: 26%;
      right: 10%;
      left: auto;
      animation-delay: 0.65s;
    }

    .${t}__retailer-badge-points {
      font-family: var(--font-body);
      font-size: 16px;
      font-weight: 700;
      color: var(--color-primary);
    }

    .${t}__retailer-badge-info {
      display: flex;
      flex-direction: column;
      gap: 1px;
    }

    .${t}__retailer-badge-label {
      font-family: var(--font-body);
      font-size: 9px;
      font-weight: 500;
      color: var(--color-text-muted);
      text-transform: uppercase;
      letter-spacing: 0.04em;
    }

    .${t}__retailer-badge-name {
      font-family: var(--font-body);
      font-size: 13px;
      font-weight: 700;
      color: var(--color-text-primary);
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .${t}__retailer-badge-icon {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      object-fit: contain;
    }

    .${t}__retailer-badge-verified {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #22C55E;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .${t}__retailer-badge-verified svg {
      width: 10px;
      height: 10px;
      fill: white;
    }

    /* Points summary overlay */
    .${t}__points-summary {
      position: absolute;
      bottom: 6%;
      left: 50%;
      transform: translateX(-50%);
      max-width: 90%;
      padding: 16px 22px;
      background: var(--color-overlay-bg);
      border-radius: 14px;
      text-align: left;
      white-space: nowrap;
      box-shadow:
        0 4px 16px rgba(0, 0, 0, 0.15),
        0 8px 32px rgba(0, 0, 0, 0.1);
      animation: ${t}-floatInCenter 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.8s backwards;
    }

    .${t}__points-summary-text {
      font-family: var(--font-display);
      font-size: clamp(16px, 1.9vw, 22px);
      font-weight: 400;
      color: var(--color-overlay-text);
      letter-spacing: -0.01em;
      white-space: nowrap;
    }

    .${t}__points-summary-sub {
      font-family: var(--font-body);
      font-size: clamp(11px, 1vw, 13px);
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      margin-top: 4px;
    }

    /* Right column \u2014 consent content */
    .${t}__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: clamp(24px, 2.6vw, 36px);
      gap: clamp(10px, 1.1vw, 14px);
      overflow-y: auto;
    }

    .${t}__pre-headline {
      font-family: var(--font-body);
      font-size: clamp(12px, 1.1vw, 14px);
      font-weight: 600;
      letter-spacing: 0.12em;
      color: var(--color-secondary);
      text-transform: uppercase;
    }

    .${t}__headline {
      font-family: var(--font-display);
      font-size: clamp(24px, 2.8vw, 34px);
      font-weight: 400;
      color: var(--color-primary);
      line-height: 1.15;
      letter-spacing: -0.01em;
      white-space: pre-line;
    }

    /* Instant-points highlight card */
    .${t}__highlight {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 14px 18px;
      background: var(--color-highlight-bg);
      border-radius: 14px;
    }

    .${t}__highlight-points {
      font-family: var(--font-display);
      font-size: clamp(30px, 3.4vw, 40px);
      font-weight: 400;
      color: var(--color-primary);
      line-height: 1;
      flex-shrink: 0;
    }

    .${t}__highlight-body {
      flex: 1;
    }

    .${t}__highlight-title-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;
    }

    .${t}__highlight-title {
      font-family: var(--font-body);
      font-size: clamp(14px, 1.3vw, 16px);
      font-weight: 700;
      color: var(--color-primary);
      line-height: 1.3;
    }

    .${t}__highlight-tag {
      flex-shrink: 0;
      padding: 4px 10px;
      background: var(--color-badge-bg);
      color: var(--color-badge-text);
      font-family: var(--font-body);
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.06em;
      border-radius: var(--radius-badge);
      text-transform: uppercase;
    }

    .${t}__highlight-sub {
      font-family: var(--font-body);
      font-size: clamp(13px, 1.2vw, 14px);
      color: var(--color-text-muted);
      line-height: 1.4;
      margin-top: 4px;
    }

    /* Recurring row */
    .${t}__recurring {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 12px 18px;
      border: 1px solid rgba(26, 43, 42, 0.1);
      border-radius: 14px;
    }

    .${t}__recurring-icon {
      width: 42px;
      height: 42px;
      flex-shrink: 0;
      border-radius: 50%;
      background: var(--color-surface);
      border: 1px solid rgba(26, 43, 42, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--color-secondary);
    }

    .${t}__recurring-icon svg {
      width: 20px;
      height: 20px;
      fill: none;
      stroke: currentColor;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
    }

    .${t}__recurring-title {
      font-family: var(--font-body);
      font-size: clamp(14px, 1.3vw, 16px);
      font-weight: 700;
      color: var(--color-primary);
      line-height: 1.3;
    }

    .${t}__recurring-sub {
      font-family: var(--font-body);
      font-size: clamp(13px, 1.2vw, 14px);
      color: var(--color-text-muted);
      line-height: 1.4;
      margin-top: 3px;
    }

    .${t}__connect-body {
      font-family: var(--font-body);
      font-size: clamp(14px, 1.3vw, 16px);
      color: var(--color-text-primary);
      line-height: 1.6;
    }

    .${t}__connect-body strong {
      font-weight: 700;
      color: var(--color-primary);
    }

    .${t}__privacy {
      display: inline-flex;
      align-items: center;
      align-self: flex-start;
      gap: 8px;
      padding: 8px 14px;
      background: rgba(27, 75, 67, 0.06);
      border-radius: var(--radius-badge);
      font-family: var(--font-body);
      font-size: clamp(12px, 1.1vw, 13px);
      font-weight: 500;
      color: var(--color-text-muted);
    }

    .${t}__privacy svg {
      width: 15px;
      height: 15px;
      flex-shrink: 0;
      fill: none;
      stroke: var(--color-secondary);
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
    }

    .${t}__cta-primary {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      width: 100%;
      margin-top: 4px;
      padding: clamp(13px, 1.3vw, 16px) clamp(24px, 3vw, 36px);
      background: var(--color-cta-bg);
      color: var(--color-cta-text);
      font-family: var(--font-body);
      font-size: clamp(13px, 1.1vw, 15px);
      font-weight: 700;
      letter-spacing: 0.06em;
      text-decoration: none;
      border: none;
      border-radius: var(--radius-button);
      cursor: pointer;
      transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
                  background-color 0.25s,
                  box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 2px 10px rgba(27, 75, 67, 0.22);
    }

    .${t}__cta-primary:hover {
      background: var(--color-cta-hover);
      transform: scale(1.02);
      box-shadow: 0 6px 22px rgba(27, 75, 67, 0.32);
    }

    .${t}__google-icon {
      width: 22px;
      height: 22px;
      flex-shrink: 0;
      background: #fff;
      border-radius: 4px;
      padding: 3px;
    }

    .${t}__cta-secondary {
      display: block;
      text-align: center;
      font-family: var(--font-body);
      font-size: clamp(13px, 1.1vw, 15px);
      font-weight: 600;
      color: var(--color-link);
      text-decoration: underline;
      text-underline-offset: 3px;
      transition: opacity 0.2s;
    }

    .${t}__cta-secondary:hover {
      opacity: 0.7;
    }

    .${t}__divider {
      height: 1px;
      background: rgba(26, 43, 42, 0.1);
      margin: 4px 0;
    }

    .${t}__powered-by {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-family: var(--font-body);
      font-size: 12px;
      font-weight: 600;
      color: var(--color-text-muted);
      text-decoration: none;
      transition: opacity 0.2s;
    }

    .${t}__powered-by:hover {
      opacity: 0.7;
    }

    .${t}__powered-by-logo {
      height: 18px;
      width: auto;
    }

    @keyframes ${t}-floatIn {
      from { opacity: 0; transform: translateY(12px); }
      to { opacity: 1; transform: translateY(0); }
    }

    @keyframes ${t}-floatInCenter {
      from { opacity: 0; transform: translateX(-50%) translateY(12px); }
      to { opacity: 1; transform: translateX(-50%) translateY(0); }
    }

    @media (max-width: 768px) {
      .${t} {
        grid-template-columns: 1fr;
        max-height: 94vh;
        overflow-y: auto;
      }

      .${t}__panel {
        min-height: 260px;
        order: -1;
      }

      .${t}__content {
        padding: 28px 22px;
        gap: 14px;
      }

      .${t}__headline {
        font-size: 28px;
      }

      .${t}__points-summary {
        padding: 12px 18px;
      }

      .${t}__points-summary-text {
        font-size: 18px;
      }

      .${t}__retailer-badge {
        padding: 6px 10px;
      }

      .${t}__retailer-badge-points {
        font-size: 13px;
      }

      .${t}__highlight,
      .${t}__recurring {
        padding: 16px;
        gap: 12px;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .${l},
      .${t},
      .${t} * {
        transition: none !important;
        animation: none !important;
      }
    }
  `}function O(i){let{content:e,product:r}=i,o=e.retailerBadges.map(n=>{let p=n.icon?`<img class="${t}__retailer-badge-icon" src="${n.icon}" alt="${n.retailer}" />`:"",c=n.verified?`<span class="${t}__retailer-badge-verified"><svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg></span>`:"";return`
      <div class="${t}__retailer-badge">
        <span class="${t}__retailer-badge-points">${n.points}</span>
        <div class="${t}__retailer-badge-info">
          <span class="${t}__retailer-badge-label">POINTS EARNED</span>
          <span class="${t}__retailer-badge-name">${p}${n.retailer}${c}</span>
        </div>
      </div>
    `}).join("");return`
    <button class="${t}__close" aria-label="Close">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
    <div class="${t}__panel">
      <img
        class="${t}__product-img"
        src="${r.imageUrl}"
        alt="${r.imageAlt}"
        loading="eager"
      />
      ${o}
      <div class="${t}__points-summary">
        <div class="${t}__points-summary-text">${e.pointsSummaryText}</div>
        <div class="${t}__points-summary-sub">${e.pointsSummarySubtext}</div>
      </div>
    </div>
    <div class="${t}__content">
      <span class="${t}__pre-headline">${e.preHeadline}</span>
      <h2 class="${t}__headline">${e.headline}</h2>

      <div class="${t}__highlight">
        <span class="${t}__highlight-points">${e.instantPoints}</span>
        <div class="${t}__highlight-body">
          <div class="${t}__highlight-title-row">
            <span class="${t}__highlight-title">${e.instantTitle}</span>
            <span class="${t}__highlight-tag">${e.instantBadge}</span>
          </div>
          <p class="${t}__highlight-sub">${e.instantBody}</p>
        </div>
      </div>

      <div class="${t}__recurring">
        <span class="${t}__recurring-icon">
          <svg viewBox="0 0 24 24"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/></svg>
        </span>
        <div>
          <div class="${t}__recurring-title">${e.recurringTitle}</div>
          <p class="${t}__recurring-sub">${e.recurringBody}</p>
        </div>
      </div>

      <p class="${t}__connect-body">${e.connectBody}</p>

      <div class="${t}__privacy">
        <svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        ${e.privacyNote}
      </div>

      <a
        class="${t}__cta-primary"
        href="${e.ctaPrimaryHref}"
        target="_blank"
        rel="noopener"
      >
        <img class="${t}__google-icon" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" aria-hidden="true" />
        ${e.ctaPrimaryText}
      </a>
      <a
        class="${t}__cta-secondary"
        href="${e.ctaSecondaryHref}"
        target="_blank"
        rel="noopener"
      >${e.ctaSecondaryText}</a>

      <div class="${t}__divider"></div>
      <a class="${t}__powered-by" href="https://www.loyaltyclaim.com/" target="_blank" rel="noopener">
        ${e.poweredByText}
        <img class="${t}__powered-by-logo" src="${e.poweredByLogoSrc}" alt="Claim" />
      </a>
    </div>
  `}var u=!1;function M(i){if(u)return;u=!0;let e=F(),r=document.createElement("style");r.textContent=H(i),document.head.appendChild(r);let o=document.createElement("div");o.className=l;let a=document.createElement("div");a.className=t,a.setAttribute("role","dialog"),a.setAttribute("aria-modal","true"),a.innerHTML=O(i),o.appendChild(a),document.body.appendChild(o);let n=document.body.style.overflow,p=!1,c=d=>{p||(p=!0,u=!1,o.classList.remove(`${l}--visible`),a.classList.remove(`${t}--visible`),e.trackHidden("claim-rewards-dialog",d),document.removeEventListener("keydown",x),document.body.style.overflow=n,setTimeout(()=>o.remove(),450))},x=d=>{d.key==="Escape"&&c("esc_key")},D=a.querySelector(`.${t}__close`),W=a.querySelector(`.${t}__cta-primary`),I=a.querySelector(`.${t}__cta-secondary`);D.addEventListener("click",()=>c("close_button")),o.addEventListener("click",d=>{d.target===o&&c("backdrop")}),W.addEventListener("click",()=>{e.trackClickedOn("claim_rewards_dialog_connect","primary")}),I.addEventListener("click",()=>{e.trackClickedOn("claim-rewards-dialog","secondary")}),document.body.style.overflow="hidden",document.addEventListener("keydown",x),requestAnimationFrame(()=>{o.classList.add(`${l}--visible`),a.classList.add(`${t}--visible`)}),e.trackShown("claim_rewards_dialog",void 0,{header_text:i.content.headline})}function $(i){new URLSearchParams(window.location.search).get(i.trigger.param)===i.trigger.value&&M(i)}var s={trigger:{type:"url-param",param:"claim_rewards",value:"open"},content:{preHeadline:"CLIGANIC REWARDS",headline:`Your rewards
start now.`,instantPoints:"+100",instantBadge:"INSTANT",instantTitle:"Points the moment you connect",instantBody:"A one-time welcome bonus, added instantly.",recurringTitle:"Then points on every purchase",recurringBody:"Amazon, iHerb, anywhere \u2014 earned automatically, forever.",connectBody:"Connect your inbox once. We'll also find the Cliganic orders you already made and <strong>credit those points too.</strong>",privacyNote:"We only ever read retailer receipts, nothing else.",ctaPrimaryText:"CONNECT WITH GOOGLE",ctaPrimaryHref:"https://api.loyaltyclaim.com/claim/v1/oauth/authorize?app_key=WBSbUotgi5amop9LJtYKsSaz6UGWOFEc7pWzM0x5&redirect_url=https%3A%2F%2Fcliganic.myshopify.com%2F%3Fclaim_connection_status%3Dsuccess",ctaSecondaryText:"See how it works",ctaSecondaryHref:"https://www.loyaltyclaim.com/",poweredByText:"Cliganic, powered by",poweredByLogoSrc:"https://www.loyaltyclaim.com/_next/image?url=%2Fclaim-logo.png&w=384&q=75",retailerBadges:[{points:"+450",retailer:"amazon",icon:"https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",verified:!1},{points:"+200",retailer:"iHerb",icon:"",verified:!0},{points:"+150",retailer:"Target",icon:"https://upload.wikimedia.org/wikipedia/commons/9/9a/Target_logo.svg",verified:!1}],pointsSummaryText:"+3,200 points already earned",pointsSummarySubtext:"All your purchases. One rewards balance."},theme:{colorPrimary:"#1B4B43",colorSecondary:"#2C6B5A",colorAccent:"#B8D4C8",colorBackground:"#F5F0E8",colorSurface:"#FDFBF7",colorTextPrimary:"#1A2B2A",colorTextMuted:"#5A6B68",colorCtaBg:"#1B4B43",colorCtaText:"#FFFFFF",colorCtaHover:"#153A34",colorBadgeBg:"#D4EDE2",colorBadgeText:"#1B7A5A",colorPanelBg:"#F9F3EE",colorOverlayBg:"#315863",colorOverlayText:"#FFFFFF",colorHighlightBg:"#E3F0E8",colorLink:"#1B4B43",cardBorderRadius:"20px",buttonBorderRadius:"10px",badgeBorderRadius:"20px"},fonts:{display:"Libre Baskerville, serif",body:"DM Sans, sans-serif",mono:"JetBrains Mono, monospace",googleFontsUrl:"https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Libre+Baskerville:wght@400;700&display=swap"},product:{name:"Organic Argan Oil",imageUrl:"https://cdn.shopify.com/s/files/1/1565/1267/files/organic-argan-oilskin-hair-oils-5412934.jpg?v=1760407924",imageAlt:"Cliganic Organic Argan Oil bottle and box"},analytics:{campaignId:"claim-rewards-dialog-default",merchantId:"WBSbUotgi5amop9LJtYKsSaz6UGWOFEc7pWzM0x5",channel:"site",formId:"oauth-consent-rewards-dialog"}};var k="claim_pixel_id";function S(){try{let e=localStorage.getItem(k);if(e){let{id:r,ts:o}=JSON.parse(e);if(Date.now()-o<864e5)return r}}catch(e){}let i=crypto.randomUUID();try{localStorage.setItem(k,JSON.stringify({id:i,ts:Date.now()}))}catch(e){}return i}var h=null;function T(){return h||(h=crypto.randomUUID()),h}function B(){let i=navigator.userAgent;return/Mobi|Android/i.test(i)?"mobile":/iPad|Tablet/i.test(i)?"tablet":"desktop"}function A(){var i;return(i=window.__st)==null?void 0:i.cid}function C(){var i;return(i=window.__st)==null?void 0:i.em}var U=null;function E(i,e,r){U={page_url:window.location.href,device_type:B(),pixel_id:S(),session_id:T(),customer_id:A(),customer_email:C(),campaign_id:r.campaignId,merchant_id:r.merchantId,merchant_guid:r.merchantGuid,channel:r.channel,widget_name:i,widget_uuid:e}}var Y=new URLSearchParams(window.location.search),j=Y.get(s.trigger.param)===s.trigger.value,R,L;if(j){let i=(L=(R=window.swellConfig)==null?void 0:R.merchantGuid)!=null?L:"WBSbUotgi5amop9LJtYKsSaz6UGWOFEc7pWzM0x5";try{let e=typeof crypto!="undefined"&&"randomUUID"in crypto?crypto.randomUUID():`${Date.now()}-${Math.random().toString(16).slice(2)}`;g.markWidgetStart("claim-rewards-dialog",e),v({guid:i,category:"claim",widgetUuid:e,preventEvents:!1,defaultContext:{is_mobile:/Mobi|Android/i.test(navigator.userAgent)}}),E("claim-rewards-dialog",e,{campaignId:s.analytics.campaignId,merchantId:s.analytics.merchantId,merchantGuid:i,channel:s.analytics.channel}),g.markWidgetEnd("claim-rewards-dialog",e),g.markWidgetLoaded("claim-rewards-dialog")}catch(e){console.warn("[claim-rewards-dialog] analytics init failed, showing dialog anyway",e)}$(s)}})();
